let keyMap = {}
let eventBus = {
  on (key, handler, tabId) {
    if (!key || !handler) return

    keyMap[key] = keyMap[key] || []
    keyMap[key].push({ tabId: tabId, handler: handler })
  },
  remove (key, tabId) {
    if (!key) return

    keyMap[key] = keyMap[key] || []
    keyMap[key] = keyMap[key].filter(item => {
      return item.tabId !== tabId
    })
  },
  emit (key, payload) {
    if (!key) return

    keyMap[key] = keyMap[key] || []
    keyMap[key].forEach(item => {
      if (typeof item.handler === 'function') {
        item.handler(payload)
      }
    })
  }
}

// export default eventBus
export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$eventBus', { value: eventBus })
  }
}
